import { useLang } from "@/App";

export default function Marquee() {
    const { t } = useLang();
    const items = [...t.marquee, ...t.marquee];
    const KANA = ["ネオン", "ナイトシティ", "エッジランナー", "ミライ"];
    return (
        <div className="relative border-y border-[#212b45] bg-[#0a0d18]/80 py-4 overflow-hidden" data-testid="marquee">
            <div className="marquee-track">
                {items.map((item, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-6 px-6 font-mono2 text-[11px] tracking-[0.3em] text-slate-500 whitespace-nowrap"
                    >
                        <span className={i % 3 === 0 ? "text-[#fcee0a]" : i % 3 === 1 ? "text-[#49f5e8]" : "text-[#ff4bd8]"}>◈</span>
                        {item}
                        <span className="kana text-[#fcee0a]/50">{KANA[i % 4]}</span>
                    </span>
                ))}
            </div>
            <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#080a12] to-transparent pointer-events-none" />
            <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#080a12] to-transparent pointer-events-none" />
        </div>
    );
}
